import { Button, DialogOverlay, DialogOverlayFooter, DialogOverlayActions, useStatusOverlay } from '@fs/zion-ui'
import React from 'react'
import { NoticeLoading } from '@fs/zion-icon'
import { Trans } from 'react-i18next/icu.macro'
import transl from './GroupDataHeader.transl'
import { useSubmitCaiReview, CAI_RESOLUTION } from '../../hooks'

export default function FinishEditMetadataRecordMetadataReviewOverlay({ overlay, onSuccess }) {
  const showStatusOverlay = useStatusOverlay()
  const [resolvingCAIReview, setResolvingCAIReview] = React.useState()

  const { submitCaiReview } = useSubmitCaiReview({
    onError: () => {
      showStatusOverlay({
        message: transl.errorMessage(),
        type: 'error',
        dismissable: true,
      })
      overlay.close()
    },
    onSuccess,
    setLoading: setResolvingCAIReview,
    resolutionType: CAI_RESOLUTION.UPDATED_METADATA,
  })

  return (
    <DialogOverlay {...overlay} title={transl.finishEditRecordMetadataReviewTitle()}>
      <Trans
        i18nKey="GroupDataHeader.finishEditRecordMetadataReviewDialogBody"
        defaults="You can continue making changes, or click <strong>Yes, Save and Submit Review</strong> to save your changes and complete the Record Metadata Review for this image group. This will return the image group for reprocessing."
      />

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button disabled={resolvingCAIReview} onClick={() => overlay.close()} emphasis="low">
            {transl.finishRecordMetadataReviewBackButton()}
          </Button>
          <Button
            data-testid="finish-record-metadata-review-button"
            disabled={resolvingCAIReview}
            Icon={resolvingCAIReview && NoticeLoading}
            onClick={submitCaiReview}
            emphasis="high"
          >
            {transl.finishEditReviewButton()}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
